import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { ReactComponent as StepComplete } from '../../assets/images/step-complete.svg';
import { ReactComponent as StepIcon } from '../../assets/images/step-icon.svg';
import { ReactComponent as StepIconCurrent } from '../../assets/images/step-icon-current.svg';

import styles from './ApplicationFlowStepper.module.scss';

export const ApplicationFlowStepper = ({ currentStep, showStrengthenStep = true }) => {
  const { t } = useTranslation('common');
  const allSteps = [
    { label: t('applicationFlowStepper.yourInfo'), description: t('applicationFlowStepper.yourInfoDesc') },
    {
      label: t('applicationFlowStepper.strengthenApplication'),
      description: t('applicationFlowStepper.strengthenApplicationDesc'),
    },
  ];
  const steps = showStrengthenStep ? allSteps : allSteps.slice(0, 1);

  return (
    <div className={styles.stepsSidebar}>
      {steps.map((step, index) => (
        <div
          key={step.label}
          className={classNames(
            styles.step,
            currentStep === index + 1 && styles.stepActive,
            currentStep > index + 1 && styles.stepCompleted
          )}
        >
          <div className={styles.stepLineContainer}>
            {currentStep > index + 1 ? <StepComplete /> : null}
            {currentStep === index + 1 ? <StepIconCurrent className={styles.stepIconCurrent} /> : null}
            {currentStep < index + 1 ? <StepIcon /> : null}
            {index !== steps.length - 1 && <div className={styles.stepLine} />}
          </div>
          <div className={styles.stepContent}>
            <p className={styles.stepLabel}>{step.label}</p>
            <p className={styles.stepDescription}>{step.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
